import { FC, useRef, useState } from "react";
import FormLayout from "../FormLayout";
import CustomInput from "../../_common/CustomInput";
import LoadingAnimation from "../../_common/Loading";
import tasksController, { IEditTaskDto } from "../../../Api/tasksController";
import { useToast } from "../../../hooks/useToast";
import { useModal } from "../../../hooks/useModal";

interface AddTaskFormProps {
    taskTitle?: string;
    taskDescription?: string;
    taskId: string;
    onRefreshTasks: () => void;
}

const AddTaskForm: FC<AddTaskFormProps> = ({
    taskTitle,
    taskDescription,
    taskId,
    onRefreshTasks,
}) => {
    const [title, setTitle] = useState<string>(taskTitle || '');
    const [description, setDescription] = useState<string>(taskDescription || '');
    const [loading, setLoading] = useState<boolean>(false);
    const toast = useRef(useToast()).current;
    const modal = useModal();

    const handleEditTask = async () => {
        if (loading) return;
        setLoading(true);
        const data: IEditTaskDto = {
            _id: taskId,
            name: title,
            description: description,
        }
        const res = await tasksController.editTask(data);
        if (!res.ok) {
            toast.error(res.message);
            setLoading(false);
            return;
        }
        toast.success(res.message);
        modal.close();
        onRefreshTasks();
    }


    const renderForm = () => {
        if (loading) return <LoadingAnimation />

        return (
            <>
                <CustomInput
                    label="Tytuł"
                    mode="text"
                    variant="filled"
                    sx={{ width: '100%' }}
                    value={title}
                    setValue={setTitle}
                />
                <CustomInput
                    label="Opis"
                    mode="multiline"
                    variant="filled"
                    sx={{ width: '100%' }}
                    value={description}
                    setValue={setDescription}
                />
            </>
        )
    }

    return (
        <FormLayout title="Edycja zadania" onClickButton={() => handleEditTask()}>
            {renderForm()}
        </FormLayout>
    )
}

export default AddTaskForm;